import { Button } from '@/components/ui/button';
import { UserPlus, Users, Plus, CheckSquare, Calendar, StickyNote, MoreVertical } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import heroImage from '@/assets/hero-family.jpg';
import { useIsMobile } from '@/hooks/use-mobile';
import type { Profile, Family, FamilyMember } from '@/hooks/useFamily';
import { ModernHero } from '@/components/ModernHero';
import { useModalNavigation } from '@/hooks/useModalNavigation';
import DirectFamilySection from '@/components/persons/DirectFamilySection';
import { usePersonProfiles } from '@/hooks/usePersonProfiles';
import { FamilySelector } from '@/components/FamilySelector';
import { NoFamilyMessage } from '@/components/NoFamilyMessage';

interface FamilyHeaderProps {
  profile: Profile;
  family?: Family | null;
  familyMembers: FamilyMember[];
  loading?: boolean;
}

export function FamilyHeader({ profile, family, familyMembers, loading }: FamilyHeaderProps) {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { openModal } = useModalNavigation();
  const { persons, createPerson, updatePerson, deletePerson, refreshPersons } = usePersonProfiles(family?.id);
  
  

  // Fonction pour obtenir le message d'accueil selon l'heure
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Bonjour';
    if (hour < 18) return 'Bon après-midi';
    return 'Bonsoir';
  };

  // Compter les adultes et enfants
  const adultMembers = familyMembers.filter(m => m.profile_id).length;
  const childrenMembers = familyMembers.filter(m => m.child_name).length;

  const heroActions = [
    {
      icon: CheckSquare,
      label: 'Créer une tâche',
      onClick: () => openModal('createTask')
    },
    {
      icon: Calendar,
      label: 'Créer un événement',
      onClick: () => openModal('createEvent')
    },
    {
      icon: UserPlus,
      label: 'Ajouter une personne',
      onClick: () => openModal('createPerson')
    },
    {
      icon: StickyNote,
      label: 'Créer une note',
      onClick: () => openModal('create_note')
    }
  ];

  return (
    <div className="relative">
      {/* Header avec sélecteur workspace et bouton paramètres */}
      <div className="absolute top-0 left-0 right-0 z-[70] flex justify-between p-4 pt-12 mt-2 pointer-events-none">
        <div className="pointer-events-auto">
          <FamilySelector />
        </div>
        <button 
          className="pointer-events-auto p-3 -m-3 rounded-full hover:bg-white/10 transition-colors"
          onClick={() => openModal('account_settings')}
        >
          <MoreVertical className="h-6 w-6 text-white" />
        </button>
      </div>

        <ModernHero
          title={`${getGreeting()} ${profile.first_name} 👋`}
          subtitle=""
          actions={heroActions}
          backgroundImage={heroImage}
          category="dashboard"
          familyId={family?.id}
          allowImageChange={true}
        />

    </div>
  );
}